import React, { useState, useEffect, useCallback } from 'react';
import {
  TitleRow,
  ContainerRow,
  SearchInputStyle,
  ControlsDiV
} from '../styledComponents';
import CustomTypography from '../../CustomComponents/CustomTypography';
import { useSelector } from 'react-redux';
import PageTitle from '../../../Utils/PageTitle';
import TanStackUserTable from '../../CustomComponents/TanStackUserTable';
import {
  RESULTS_PER_PAGE,
  SEARCH_DELAY
} from '../../../Constants/StringConstants';
import { createBillerColumns } from './tanstackColumnConfig';
import AddBillersForm from './AddBillersForm';
import CustomSideDrawer from '../../CustomComponents/CustomSideDrawer';

import { notification } from 'antd';
import { SearchOutlined, PlusOutlined, DownloadOutlined } from '@ant-design/icons';
import { useDebounce } from '../../../Utils/Debounce';
import { AddButton } from '../styledComponents';
import { exportToExcel } from '../../../Utils/ExcelExport';
import { reInviteUser } from '../../../Apis/User';
import FacilityFilter from '../../CustomComponents/FacilityFilter';
import { getUserFacilities } from '../../../Apis/User';
import { disableOrEnableUser } from '../../../Apis/ClinicAdmin';
import { AddBiller, listAll, editBiller } from '../../../Apis/Biller';
const Billers = () => {
  const [theme] = useSelector(state => [state.themeReducer]);
  const [searchString, setSearchString] = useState('');
  const [total, setTotal] = useState(0);
  const [admins, setAdmins] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [addDrawerVisible, setAddDrawerVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [filterKey, setFilterKey] = useState('name');
  const [sortOrder, setSortOrder] = useState('');
  const [facilityIds, setFacilityIds] = useState([]);
  const [facilities, setFacilities] = useState();
  const [clearFiltersTrigger, setClearFiltersTrigger] = useState(0);
  const userData = useSelector(state => state.userReducer);
  const notClinicAdmin = userData.userType !== 'clinicAdmin' && userData.userType !== 'admin';

  // const submitHandler = values => {
  //   setSubmitLoading(true);
  //   const payload = values;
  //   values.phoneNumber.number = values.phoneNumber.number.replace(
  //     values.phoneNumber.countryCode,
  //     ''
  //   );

  const submitHandler = values => {
    // values.reviewerList = values.reviewerList.includes('none')
    //   ? []
    //   : values.reviewerList;

    setSubmitLoading(true);
    const payload = values;
    values.phoneNumber.number = values.phoneNumber.number.replace(
      values.phoneNumber.countryCode,
      ''
    );
    if (selectedItem) {
      payload.id = selectedItem.id;
      editBiller(payload)
        .then(response => {
          if (response.data.success) {
            notification['success']({
              message: 'Updated',
              description: 'Biller details updated.'
            });
            setSubmitLoading(false);
            setAddDrawerVisible(false);
            setSelectedItem(null);
            fetchAll();
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setSubmitLoading(false);
          }
        })
        .catch(err => {
          setSubmitLoading(false);
          console.log(err);
        });
    } else {
      AddBiller(payload)
        .then(response => {
          if (response.data.success) {
            notification['success']({
              message: 'Added',
              description: 'Biller added successfully'
            });
            setSubmitLoading(false);
            setAddDrawerVisible(false);
            setSelectedItem(null);
            fetchAll();
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setSubmitLoading(false);
          }
        })
        .catch(err => {
          setSubmitLoading(false);
          console.log(err);
        });
    }
  };

  const reInvite = id => {
    reInviteUser(id)
      .then(response => {
        if (response.data.success) {
          notification['success']({
            message: 'Success',
            description: response.data.message
          });
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const disableUser = id => {
    disableOrEnableUser(id)
      .then(response => {
        if (response.data.success) {
          notification['success']({
            message: 'Success',
            description: response.data.message
          });
          fetchAll(0);
          setCurrentPage(0);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  const fetchAll = () => {
    setLoading(true);
    // Simplified API call - backend sends all items without pagination params
    listAll()
      .then(response => {
        setLoading(false);
        if (response.data.success) {
          setTotal(response.data.size);
          setAdmins(response.data.result);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        setLoading(false);
      });
  };

  const onChangeHandler = value => {
    setCurrentPage(0);
    setSearchString(value);
  };

  const debounceOnChange = useCallback(
    useDebounce(onChangeHandler, SEARCH_DELAY),
    []
  );

  const handleExport = () => {
    // Apply filters to data
    let filteredData = admins;

    // Apply search filter
    if (searchString) {
      const searchLower = searchString.toLowerCase();
      filteredData = filteredData.filter(biller => {
        return (
          (biller.fullName && biller.fullName.toLowerCase().includes(searchLower)) ||
          (biller.email && biller.email.toLowerCase().includes(searchLower)) ||
          (biller.phoneNumber &&
            `${biller.phoneNumber.countryCode}${biller.phoneNumber.number}`.includes(searchLower))
        );
      });
    }

    // Custom export columns
    const exportColumns = [
      { id: 'id', header: 'ID', accessorKey: 'id' },
      { id: 'fullName', header: 'Name', accessorKey: 'fullName' },
      { id: 'email', header: 'Email', accessorKey: 'email' },
      { id: 'phoneNumber', header: 'Phone Number', accessorKey: 'phoneNumber' }
    ];

    exportToExcel(filteredData, exportColumns, 'Billers');
  };


  useEffect(() => {
    fetchAll();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <PageTitle title='Billers' />
      <ContainerRow gutter={[0, 40]}>
        <TitleRow justify='space-between'>
          <CustomTypography color={theme['@text-color']}>
            Billers
          </CustomTypography>
          <ControlsDiV>
            <AddButton
              icon={<PlusOutlined />}
              type='primary'
              onClick={() => setAddDrawerVisible(true)}
            >
              Add
            </AddButton>
            <SearchInputStyle
              placeholder='Search'
              prefix={<SearchOutlined />}
              value={searchString}
              onChange={event => {
                setSearchString(event.target.value);
                debounceOnChange(event.target.value);
              }}
            />
            <AddButton
              icon={<DownloadOutlined />}
              onClick={handleExport}
            >
              Export to Excel
            </AddButton>
            <AddButton
              onClick={() => {
                setSearchString('');
                setClearFiltersTrigger(t => t + 1);
              }}
            >
              Clear Filter
            </AddButton>
          </ControlsDiV>
        </TitleRow>
        <TanStackUserTable
          data={admins}
          columns={createBillerColumns(
            setSelectedItem,
            setAddDrawerVisible,
            disableUser,
            reInvite,
            notClinicAdmin
          )}
          loading={loading}
          searchValue={searchString}
          storageKey='users_page_billers'
          clearFiltersTrigger={clearFiltersTrigger}
        />

        <CustomSideDrawer
          title={selectedItem ? 'Edit Biller' : 'Add Biller'}
          placement='right'
          closable={false}
          onClose={() => {
            setSelectedItem(null);
            setAddDrawerVisible(false);
          }}
          visible={addDrawerVisible}
          width={400}
          destroyOnClose={true}
        >
          <AddBillersForm
            facilities={facilities}
            selectedItem={selectedItem}
            submitHandler={submitHandler}
            submitLoading={submitLoading}
          />
        </CustomSideDrawer>
      </ContainerRow>
    </>
  );
};

export default Billers;
